import { RouteConfig } from 'vue-router';
import applicationsRoutes from './applicationsRoutes';
import profileRoutes from './profileRoutes';
import providersDashboardRoutes from './providersDashboard';
import availabilityRoutes from './availabilityRoutes';
import bookingsRoutes from './bookingsRoutes';
import sitterOnboardingRoutes from './sitterOnboardingRoutes';

const providerRoutes = [
  ...applicationsRoutes,
  ...profileRoutes,
  ...providersDashboardRoutes,
  ...availabilityRoutes,
  ...bookingsRoutes,
  ...sitterOnboardingRoutes,
] as RouteConfig[];

export default providerRoutes;
